import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';

const DisconnectDialog = ({ visible, onHide, onDisconnect }) => {
    const disconnectDialogFooter = (
        <>
            <Button label="Cancel" icon="pi pi-times" className="p-button-text" onClick={onHide} />
            <Button 
                label="Disconnect" 
                icon="pi pi-sign-out" 
                className="p-button-danger" 
                onClick={() => {
                    onHide();
                    onDisconnect();
                }} 
            />
        </>
    );

    return (
        <Dialog
            visible={visible}
            header="Disconnect Google Calendar"
            modal
            footer={disconnectDialogFooter}
            onHide={onHide}
            className="disconnect-dialog frazza-dialog-sm"
        >
            <div className="event-delete-confirmation">
                <div className="frazza-alert-icon danger">
                    <i className="pi pi-google" />
                </div>
                <div className="frazza-alert-content">
                    <h4 className="frazza-alert-title">Disconnect from Google?</h4>
                    <p className="frazza-alert-message">This will remove all events created by Frazza from your Google Calendar. This action cannot be undone.</p>
                </div>
            </div>
        </Dialog>
    );
};

export default DisconnectDialog;